import { Link } from "react-router-dom";
import styles from './ProductCommentSection.module.scss';


export default function ProductCommentSection(props) {
  return (
    <>
        <div className={`bg-white p-4 lgtBackground mb-3`}>
            <div className={`mb-2 d-flex`}>
                <i className='bi bi-chat-right-text me-2 big text-primary'></i>
                <span>
                    {props.data.comment}
                </span>
            </div>
            <div className={`d-flex align-items-start align-sm-items-center flex-column flex-sm-row ${styles.productContainer}`}>
                <Link to={`/product/${props.data.product_id}`} className={`${styles.productImage} mb-3 mb-sm-0 me-sm-2`}>
                    <img 
                    src={`${!props.data.product.image ? '/images.png' : `${process.env.REACT_APP_API_URL}${props.data.product.image}`}`}
                    className='img-fluid'/>
                </Link>
                <div>
                    <Link to={`/product/${props.data.product_id}`} className={`${styles.productName} text-decoration-none fw-semibold`}>
                        {props.data.product.title}
                    </Link>
                    <div className={`${styles.productPrice}`}>
                        <div className={`${styles.priceBox}`}>
                            <div className={`${styles.price}
                                ${props.data.product.discount > 0 ? `${styles.regularPrice} text-decoration-line-through` : `fw-bold`}`
                                }>
                                <span>$</span>
                                {props.data.product.price}
                            </div>
                            {
                                props.data.product.discount > 0 &&(
                                    <div className={`fw-bold ${styles.price} ${styles.discountedPrice}`}>
                                        <span>$</span>
                                        {props.data.product.discount_price}
                                    </div>)
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </>
  )
}
